import { TEMPORARY_COMPANY_PREFIX } from '../config';

/**
 * Ideally this shouldn't be needed: the reducers should expose this information in a convenient fashion
 * But since with the current design we need to access this nested piece of data from various components, the best option for
 * now is to have an helper to do it in a centralized place.
 *
 * @param {} state of the application
 * @returns {boolean} is the user administrator of the currently selected company?
 */
export const isAdmin = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].userIsAdmin;
};

export const isGuest = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].userIsGuest;
};

export const isTempCompany = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].displayName.indexOf(TEMPORARY_COMPANY_PREFIX) == 0;
};

export const getMarketingTags = state => {
	return state.companies.rawDataById &&
		state.companies.selectedId &&
		state.companies.rawDataById[state.companies.selectedId] &&
		state.companies.rawDataById[state.companies.selectedId].marketingTags;
};


// WEBPACK FOOTER //
// ./src/utils/state.js